module.exports = __webpack_public_path__ + "static/media/051-american-football-player.b834aa7c.svg";